import classNames from 'classnames';
import moment from 'moment';
import { debounce, set } from 'lodash';
import 'rc-datetime-picker/dist/picker.css';
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import { first, take } from 'rxjs/operators';
import { Button, DatePickerComp, MultiselectWithSearchR, SelectD, SelectWithSearch, UnfocusableWrapper } from '..';
import { UploadIcon } from '../../../assets/images/icons';
import { setCompanyData, setMessageBar } from '../../../reduxStore/actions/flowActions';
import { getAllCompanies, getCompanyDetails, setCompanyDetails, setCompanyLogo, updateCompanyDetailsById } from '../../../services/company.service';
import { industryFields, numberOfEmployees, statusArray, uncachedUrl } from '../../../shared/utility';
import { DatePickerRC, po } from '../../common';
import cls from './CompanyDataUpdate.module.scss';
import { usePermissions } from '../../../hooks/usePermisions';
import { isMobile } from 'react-device-detect';
import { OptionSection } from '../../SideMenuEntries/ModulesComp/ModulesOptionsModal';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { ChakraProvider } from "@chakra-ui/react";
import { Paint } from '../../common/UI/Paint/Paint';
import ModuleLists from '../../SideMenuEntries/ModulesComp/ModuleLists';
import { deleteFileComponent, getAllFiles } from '../../../services/components.service';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const R = require('ramda');


export const CompanyDataUpdate = props => {
	const { settingsContainerClass, datePickerRC, feValidation, bypassTriggerValidation, setElementsTouched } = props;
	const { companyData, companyPositionsArray, components } = useSelector(state => state.flowReducer);
	const { authenticatedUser } = useSelector(state => state.authReducer);
	const [selectedCompany, setSelectedCompany] = useState(companyData);
	const { isOnboarding } = useSelector(store => store.modalsReducer);
	const [loading, setLoading] = useState(false);
	const [show, setShow] = useState(false);
	const [photos, setPhotos] = useState([]);

	const dispatch = useDispatch();
	const [permis] = usePermissions();
	const onDrop = useCallback(
		acceptedFiles =>
			acceptedFiles.forEach(file => {
				setLogoError('');

				dispatch(setCompanyData({ logo: '' }));

				if (file?.type?.toString().indexOf('image/') > -1 && ['jpeg', 'jpg', 'png'].indexOf(file?.type?.toString().split('/')[1]) > -1) {
					let reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onloadend = _e => {
						const formData = new FormData();
						formData.append('logo', file);
						setCompanyLogo(file)
							.pipe(first())
							.subscribe({
								next: _data => { },
								error: error => {
									setLogoError(error?.data);
								},
								complete: () => { },
							});
					};
				}
			}),
		[]
	);
	const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
	const [logoError, setLogoError] = useState('');
	const [compantDetails_apiError, setCompanyDetails_ApiError] = useState('');

	

	const [fieldsErrors, setFieldErrors] = useState({
		name: '',
		display_name: '',
		founding_date: '',
		employees_no: '',
		industry: '',
	});

	const settingFieldErors = useCallback(
		val => {
			!bypassTriggerValidation && setFieldErrors({ ...val });
		},
		[bypassTriggerValidation]
	);
	useEffect(() => {
		settingFieldErors({ ...feValidation });
	}, [feValidation]);

	const sendCompanyDetails = (payload, mode) => {
		setLoading(true);
		setCompanyDetails(payload)
			.pipe(first())
			.subscribe({
				next: data => {
					//delete data.misc_info
					data.misc_info = {};
					localStorage.setItem('companyData', JSON.stringify(data));
					window.scrollTo({ top: 0, behavior: 'smooth' })
					setLoading(false);
				},
				error: error => {
					setLoading(false);
				},
			});
	}
	const renderDropZone = useCallback(() => {
		return permis[po.company.profile.update] === true ? (
			<div className={cls.logoDragContainer} app-drag-active={isDragActive ? 'true' : 'false'} {...getRootProps()} style={{ border: selectedCompany?.logo?.length > 2 ? '0' : 'solid silver 2px' }}>
				<input {...getInputProps()} className={cls.logoDragInput} accept="*,image/png, image/jpeg, image/jpg" />
				{isDragActive ? (
					<div className={cls.logoContentContainer}>
						<UploadIcon className={cls.logoUploadIcon} />
					</div>
				) : (
					<div className={cls.logoContentContainer}>
						{selectedCompany?.logo?.length > 2 ? (
							<img alt="lg" src={uncachedUrl(selectedCompany?.logo)} className={cls.logoUrlImg} />
						) : (
							<div className={cls.logoUploadPictureContainer}>
								<UploadIcon className={cls.logoUploadIcon} />
								<p style={{ fontSize: '10px' }}>
									{'Company Logo'}
								</p>
							</div>
						)}
					</div>
				)}
			</div>
		) : (
			<div className={cls.logoDragContainer} app-drag-active={'false'} style={{ border: '0' }}>
				<div className={cls.logoContentContainer}>{selectedCompany?.logo?.length > 2 && <img alt="lg" src={uncachedUrl(selectedCompany?.logo)} className={cls.logoUrlImg} />}</div>
			</div>
		);
	}, [selectedCompany, permis]);

	const foundingDateChangeHandler = date => {
		setSelectedCompany({ ...selectedCompany, founding_date: moment(date).format('YYYY-MM-DD') });
		if (companyData.status === 'onboarding') {
			companyData.founding_date = moment(date).format('YYYY-MM-DD');
		}
	};

	const employeesChangeHandler = e => {
		setSelectedCompany({ ...selectedCompany, employees_no: e.value })
		if (companyData.status === 'onboarding') {
			companyData.employees_no = e.value;
			// console.log(companyData)
		}
	};

	const singleUserChangeHandler = e => {
		setSelectedCompany({ ...selectedCompany, core_values: { ...selectedCompany.core_values, singleUser: e.value } });
	};
	const industryChangeHandler = e => {
		setSelectedCompany({ ...selectedCompany, industry: e.target.value });
		if (companyData.status === 'onboarding') {
			companyData.industry = e.target.value;
		}
	};

	return (
		<div className={cls.host}>

			<LabeledField >
				{renderDropZone()}
				{logoError?.length > 0 && <p className={cls.logoErrorText}>{logoError}</p>}
			</LabeledField>

			<Tabs
				style={{ fontFamily: 'var(--app-text-main-font)', fontSize: isMobile ? '18px' : '20px', marginTop: '40px' }}
			>
				<TabList>
					<Tab>
						<p>
							{isMobile ? 'Basic' : 'Basic Information'}
						</p>
					</Tab>
					{permis[po.company.profile.update] === true &&
						<Tab>
							<p>
								{isMobile ? 'Admin' : 'Admin Settings'}
							</p>
						</Tab>
					}
					{(authenticatedUser.user_type === 'superadmin' || authenticatedUser.user_type === 'admin') &&
						<Tab>
							<p>
								{isMobile ? 'Advanced' : 'Advanced Settings'}
							</p>
						</Tab>
					}
					{(authenticatedUser.user_type === 'superadmin' || authenticatedUser.user_type === 'admin') &&
						<Tab>
							<p>
								{'Home Page'}
							</p>
						</Tab>
					}
					{(authenticatedUser.user_type === 'superadmin' || authenticatedUser.user_type === 'admin') &&
						<Tab onClick={() => getAllFiles(`files/${companyData.id}`)
							.pipe(first())
							.subscribe({
								next: data => {
									setPhotos(data);
								}
							})}
							>
							<p>
								{isMobile ? 'Files' : 'Files and Photos'}
							</p>
						</Tab>
					}
				</TabList>

				<TabPanel id="Basic" style={{ padding: '40px 0' }}>
					<div className={cls.companyDataWrapper}>
						<UnfocusableWrapper className={classNames(cls.companySettingsContainer, settingsContainerClass)}>
							<div style={{ width: isMobile ? '100%' : '60%', marginBottom: '10px' }}>
								<LabeledField label={'Company Name'} error={fieldsErrors.name}>
									<input
										readOnly={permis[po.company.profile.update] === false}
										type="text"
										name="comapny-name"
										className={cls.inputField}
										placeholder="Company Name"
										defaultValue={selectedCompany?.name}
										onBlur={e => {
											setSelectedCompany({ ...selectedCompany, name: e.target.value })
											if (companyData.status === 'onboarding') {
												companyData.name = e.target.value;
											}
										}}
									/>
								</LabeledField>


								<LabeledField label={'Display Name'} error={fieldsErrors.display_name}>
									<input
										readOnly={permis[po.company.profile.update] === false}
										type="text"
										name="company-display-name"
										className={cls.inputField}
										placeholder="Company Name"
										defaultValue={selectedCompany?.display_name}
										onBlur={e => {
											setSelectedCompany({ ...selectedCompany, display_name: e.target.value });
											if (companyData.status === 'onboarding') {
												companyData.display_name = e.target.value;
											}
										}}
									/>
								</LabeledField>


								<LabeledField label={'Flowhero Page URL'} error={fieldsErrors.name}>
									<input type="text" name="messages" disabled={true} className={cls.inputField} value={`https://www.flowhero.app/#/pages/home/${selectedCompany?.slug}`} />
								</LabeledField>

								{!isOnboarding && <LabeledField label={'Founding Date'} error={fieldsErrors.founding_date}>
									{permis[po.company.profile.update] === true ? (
										datePickerRC ? (
											<DatePickerRC nonEditable={po.company.profile.update} value_date={selectedCompany?.founding_date} maxDate={moment()} onDateChange={foundingDateChangeHandler} containerClassName={cls.datePickerRCContainer} />
										) : (
											<DatePickerComp
												nonEditable={po.company.profile.update}
												value={moment(selectedCompany?.founding_date ?? moment()).format('Do of MMMM YYYY')}
												selected={new Date(moment(selectedCompany?.founding_date ?? moment().format('YYYY-MM-DD'), 'YYYY-MM-DD'))}
												dateChangeHandler={foundingDateChangeHandler}
												inputContainerClassName={cls.foundingDateInputContainer}
												inputClassName={cls.inputFieldOverlay}
												inputStyle={{
													textAlign: selectedCompany?.founding_date?.length > 0 ? 'left' : 'center',
													border: 'none',
													height: 'auto',
													fontWeight: 'bold',
													backgroundColor: 'var(--app-color-gray-lightest)'

												}}
												hasCalendarIcon
												placeholder={'Due Date'}
											/>
										)
									) : (
										<input readOnly={true} type="text" name="input-founding_date" className={cls.inputField} value={moment(selectedCompany?.founding_date ?? moment()).format('Do of MMMM YYYY') ?? ''} />
									)}
								</LabeledField>}

								<LabeledField label={'Company Size'} error={fieldsErrors.employees_no}>
									{permis[po.company.profile.update] === true ? (
										<SelectD
											title=""
											placeholder="No. of Employees"
											tmiClassName={cls.selectText}
											molclassname={cls.employeesMOL}
											moliclassname={cls.rowsField}
											className={cls.inputField}
											onChange={employeesChangeHandler}
											items={numberOfEmployees}
											defaultSelected={numberOfEmployees.find(i => i.value === selectedCompany?.employees_no)}
										/>
									) : (
										<input readOnly={true} type="text" name="input-number-of-employes" className={cls.inputField} value={numberOfEmployees.find(i => i.value === selectedCompany?.employees_no)?.label ?? ''} />
									)}
								</LabeledField>

								<LabeledField label={'Industry'} error={fieldsErrors.industry}>
									{permis[po.company.profile.update] === true ? (
										<SelectWithSearch
											id={'industry-selection'}
											triggerType={'chevron'}
											itemType={'no-item-icons'}
											inputStyle={{ backgroundColor: 'var(--app-color-gray-lightest)' }}
											className={cls.inputField}
											inputClassName={cls.selectText}
											molclassname={cls.industryMOL}
											moliclassname={cls.industryMOLI}
											title=""
											placeholder={'Select industry...'}
											onChange={val => {
												industryChangeHandler({ target: { value: val.label } });
											}}
											defaultSelectedItem={industryFields?.find(i => i.label == selectedCompany?.industry)}
											items={industryFields}
										/>
									) : (
										<input readOnly={true} type="text" name="input-number-of-employes" className={cls.inputField} value={industryFields?.find(i => i.label == selectedCompany?.industry)?.label ?? ''} />
									)}
								</LabeledField>

								{permis[po.company.profile.update] === true && !isOnboarding && <Button
									loading={loading}
									style={{ width: '200px', marginTop: '40px' }}
									title={'Update'}
									clicked={() => {
										sendCompanyDetails(selectedCompany);
									}}
								/>}
							</div>

							<div>{compantDetails_apiError?.length > 0 && <p className={cls.errorGeneralText}>{compantDetails_apiError} </p>}</div>
						</UnfocusableWrapper>
					</div>
				</TabPanel>



				{permis[po.company.profile.update] === true &&

					<TabPanel id="Admin" style={{ padding: '40px 0', width: '100%' }}>
						<LabeledContainer label={''}>
							<div className={cls.companyDataWrapper}>
								<UnfocusableWrapper className={classNames(cls.companySettingsContainer, settingsContainerClass)}>
									<div style={{ width: isMobile ? '100%' : '60%', marginBottom: '10px' }}>
										{selectedCompany?.misc_info?.sauth && (
											<div style={{ flex: 1, display: isOnboarding ? 'none' : '', marginBottom: '10px' }}>
												<LabeledField label={'Position assigned to single-position users'} error={fieldsErrors.industry}>
													{permis[po.company.profile.update] === true && (
														<SelectWithSearch
															id={'industry-selection'}
															triggerType={'chevron'}
															itemType={'no-item-icons'}
															className={cls.inputField}
															inputClassName={cls.selectText}
															molclassname={cls.industryMOL}
															moliclassname={cls.industryMOLI}
															title=""
															placeholder={''}
															onChange={position => {
																singleUserChangeHandler(position);
															}}
															defaultSelectedItem={companyPositionsArray?.find(i => i.value == selectedCompany?.core_values?.singleUser)}
															items={companyPositionsArray}
														/>
													)}
												</LabeledField>
											</div>
										)}
										<div style={{ marginTop: '0px', display: isOnboarding ? 'none' : permis[po.company.profile.update] === true ? '' : 'none' }}>
											<div style={{ marginTop: '1px', display: permis[po.company.profile.update] === true ? '' : 'none' }}>
												<div style={{ marginBottom: '10px' }}>
													<LabeledField label={'Welcome Message'} error={fieldsErrors.name}>
														<textarea
															type="text"
															name="messages"
															className={cls.inputField}
															placeholder="Default message shown after logging in"
															defaultValue={selectedCompany?.company_standards?.welcome ?? ''}
															onBlur={e => {
																localStorage.setItem('showInfo', true);
																setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, welcome: e.target.value } })
															}}
															style={{ height: '100px' }}
														/>
													</LabeledField>
												</div>

												<div style={{ marginBottom: '10px' }}>
													<LabeledField label={'Welcome Banner'} error={fieldsErrors.name}>
														<textarea
															type="text"
															name="messages"
															className={cls.inputField}
															placeholder={'Background image shown after logging in. Use .jpg, .png URLs'}
															defaultValue={selectedCompany?.company_standards?.banner ?? ''}
															onBlur={e => {
																localStorage.setItem('showInfo', true);
																setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, banner: e.target.value } })
															}}
															style={{ height: '100px' }}
														/>
													</LabeledField>
												</div>
												<div style={{ marginBottom: '10px' }}>
													<LabeledField label={'Mobile Splash Screen'} error={fieldsErrors.name}>
														<textarea
															type="text"
															name="messages"
															className={cls.inputField}
															placeholder={'Background image for your home page. Use .jpg, .png URLs'}
															defaultValue={selectedCompany?.company_standards?.hbanner ?? ''}
															onBlur={e => {
																localStorage.setItem('showInfo', true);
																setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, hbanner: e.target.value } })
															}}
															style={{ height: '100px' }}
														/>
													</LabeledField>
												</div>
												<div style={{ marginBottom: '10px' }}>
													<LabeledField label={'Header message'} error={fieldsErrors.name}>
														<textarea
															type="text"
															name="messages"
															className={cls.inputField}
															placeholder="Primary text description used in your home page"
															defaultValue={selectedCompany?.company_standards?.message ?? ''}
															onBlur={e => {
																localStorage.setItem('showInfo', true);
																setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, message: e.target.value } })
															}}
															style={{ height: '200px' }}
														/>
													</LabeledField>
												</div>
												<div style={{ marginBottom: '10px' }}>
													<LabeledField label={'Header sub message'} error={fieldsErrors.name}>
														<textarea
															type="text"
															name="messages"
															className={cls.inputField}
															placeholder="Secondary text description used in your home page"
															defaultValue={selectedCompany?.company_standards?.subMessage ?? ''}
															onBlur={e => {
																localStorage.setItem('showInfo', true);
																setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, subMessage: e.target.value } })
															}}
															style={{ height: '200px' }}
														/>
													</LabeledField>
												</div>
											</div>
										</div>
									</div>
									<div></div>
									<div>{compantDetails_apiError?.length > 0 && <p className={cls.errorGeneralText}>{compantDetails_apiError} </p>}</div>
								</UnfocusableWrapper>
							</div>
						</LabeledContainer>

						{permis[po.company.profile.update] === true && !isOnboarding && <Button
							loading={loading}
							style={{ width: '200px' }}
							title={'Update'}
							clicked={() => {
								sendCompanyDetails(selectedCompany);
							}}
						/>}
					</TabPanel>}

				{(authenticatedUser.user_type === 'superadmin' || authenticatedUser.user_type === 'admin') &&
					<TabPanel id="Advanced" style={{ padding: '40px 0', width: '100%' }}>
						<CompanyAdmin user={authenticatedUser} company={companyData} ccompany={authenticatedUser.user_type !== 'superadmin' ? companyData : undefined} />
					</TabPanel>}

				{(authenticatedUser.user_type === 'superadmin' || authenticatedUser.user_type === 'admin') &&
					<TabPanel id="Home Page" style={{ padding: '40px 0', width: '100%' }}>
						<div style={{ overflowX: 'auto', width: 'inherit' }}>
							<ChakraProvider resetCSS={false}>
								<Paint data={selectedCompany?.company_standards?.web}
									control={true}
									visible={true}
									onUpdate={e => {
										console.log(e)
										sendCompanyDetails({
											...selectedCompany, company_standards: { ...selectedCompany?.company_standards, web: e }
										});
										setSelectedCompany({
											...selectedCompany, company_standards: { ...selectedCompany?.company_standards, web: e }
										})
									}

									} />
							</ChakraProvider>
						</div>
					</TabPanel>}
				{(authenticatedUser.user_type === 'superadmin' || authenticatedUser.user_type === 'admin') &&
					<TabPanel id="Photos" style={{ padding: '40px 0', width: '100%' }}>
						<ModuleLists
							columns={['URL', 'Status', 'Actions']}
							list={photos.map(photo => {
								const found = components.find(c => c.component_fields.find(cf => cf.value?.includes(photo)))
								return {
									URL: photo,
									Status: found ? `Used (${found.title})` : 'Unused',
									'Actions': <div style={{ display: 'flex', justifyContent: 'center', minWidth: '80px', maxWidth: '120px' }}>
										<FontAwesomeIcon icon={faTrash} onClick={() => {
											deleteFileComponent(photo).subscribe({
												next: data => {
													setPhotos(photos.filter(p => p !== photo));
												}
											});
										}}
										/>
									</div>,
								}
							})}
						/>
					</TabPanel>}
			</Tabs>

		</div>
	);
};

const LabeledContainer = props => {
	const { label, children } = props;
	return (
		<div className={cls.labeledContainerHost}>
			<p className={cls.labeledContainerLabel}>{label}</p>
			{children}
		</div>
	);
};
const LabeledField = props => {
	const { label, error, children } = props;
	return (
		<div className={cls.labeledFieldHost}>
			<p className={cls.labeledFieldLabel}>{label}</p>
			{children}
			{error?.length > 0 && <p className={cls.labeledFieldError}>{error}</p>}
		</div>
	);
};

export const CompanyAdmin = props => {
	const { company, user } = props;
	const { companyData, allModules } = useSelector(state => state.flowReducer);
	const dispatch = useDispatch();
	const [date, setDate] = useState(new Date());

	const [companies, setCompanies] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState({ ...company });
	const [ruleType, setRuleType] = useState();
	const [template, setTemplate] = useState();
	const [error, setError] = useState(false);

	const [loading, setLoading] = useState(false);
	const [companyStatusArray,] = useState([
		{ label: 'On Trial', value: 'on_trial' },
		{ label: 'Trial Ended', value: 'trial_ended' },
		{ label: 'Active', value: 'active' },
		{ label: 'Inactive', value: 'inactive' },
		{ label: 'New', value: 'onboarding' },
	]);

	const { companyPositionsArray, companyDepartments } = useSelector(store => store.flowReducer);

	const [multiselectItems,] = useState(R.sortWith([R.ascend(R.prop('department_name'))])(companyPositionsArray?.map(i => ({
		label: i.label,
		value: i.value,
		department_name: i.department,
		department_id: companyDepartments.find(d => d.label == i.department)?.value,
	}))));


	const rulesTypeArray = [{ label: 'Status', value: 'status', }, { label: 'Self-assignable positions', value: 'positions' }];
	useEffect(() => {
		user.user_type === 'superadmin' && getAllCompanies()
			.pipe(take(1))
			.subscribe({
				next: data => {
					setCompanies(
						data
							.map(co => {
								return { label: co.name, value: co.id, company: co };
							})
					);
				},
				error: error => { },
				complete: () => { },
			});
	}, []);

	const isJson = (str) => {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	return (
		<div style={{ width: '60%', marginBottom: '500px', minWidth: '300px' }}>
			{user.user_type === 'superadmin' && (
				<LabeledField label={'Select Company'}>
					<SelectWithSearch
						id={'company-selection'}
						triggerType={'chevron'}
						itemType={'no-item-icons'}
						className={cls.inputField}
						inputClassName={cls.selectText}
						molclassname={cls.industryMOL}
						moliclassname={cls.industryMOLI}
						onChange={val => {
							setSelectedCompany(undefined);
							setTimeout(() => {
								setSelectedCompany(val.company);
								setDate(val.company.trial_ends_at)
							}
							);
						}}
						items={companies}
					/>
				</LabeledField>
			)}
			<br />
			<LabeledField label={'ID:'}>
				<input type="text" className={cls.inputField} value={selectedCompany?.id} disabled />
			</LabeledField>
			{selectedCompany && user.user_type === 'superadmin' && (
				<LabeledField label={'Company Status'}>
					<SelectWithSearch
						id={'status-selection'}
						triggerType={'chevron'}
						itemType={'no-item-icons'}
						className={cls.inputField}
						inputClassName={cls.selectText}
						molclassname={cls.industryMOL}
						moliclassname={cls.industryMOLI}
						onChange={val => {
							selectedCompany.status = val.value;
						}}
						defaultSelectedItem={companyStatusArray.find(i => i.value === selectedCompany.status)}
						items={companyStatusArray}
					/>
				</LabeledField>
			)}
			<br />
			{selectedCompany && user.user_type === 'superadmin' && (
				<LabeledField label={'Trial Date End'}>
					<DatePickerComp
						nonEditable={po.company.profile.update}
						value={moment(date ?? moment()).format('Do of MMMM YYYY')}
						selected={new Date(moment(date ?? moment().format('YYYY-MM-DD'), 'YYYY-MM-DD'))}
						dateChangeHandler={date => setDate(date)}
						inputContainerClassName={cls.inputField}
						inputStyle={{
							border: 'none',
							height: 'auto',
							padding: '10px'
						}}
						hasCalendarIcon
					/>
				</LabeledField>
			)}

			{Object.keys(selectedCompany?.misc_info ?? []).map((key, index) => {
				if (typeof selectedCompany?.misc_info[key] === 'string' && !(key === 'lock' || (key === 'map' && user.user_type !== 'superadmin'))) {
					return (
						<LabeledField key={index} label={key}>
							<input type="text" className={cls.inputField} value={selectedCompany?.misc_info[key]} onChange={e => setSelectedCompany({ ...selectedCompany, misc_info: { ...selectedCompany.misc_info, [key]: e.target.value } })} />
						</LabeledField>
					);
				}
			})}
			<br />

			{selectedCompany && user.user_type === 'superadmin' && (
				<LabeledField label={'Set Single User Position'}>
					<SelectWithSearch
						id={'position-selection'}
						triggerType={'chevron'}
						itemType={'no-item-icons'}
						className={cls.inputField}
						inputClassName={cls.selectText}
						molclassname={cls.industryMOL}
						moliclassname={cls.industryMOLI}
						onChange={val => {
							if (val) selectedCompany.core_values = { ...selectedCompany?.core_values, singleUser: val.value };
						}}
						defaultSelectedItem={(selectedCompany?.positions?.map(pos => {
							return { label: pos.name, value: pos.id, position: pos };
						}) ?? [])?.find(i => i.value == selectedCompany?.core_values?.singleUser)}

						items={
							selectedCompany?.positions?.map(pos => {
								return { label: pos.name, value: pos.id, position: pos };
							}) ?? []
						}
					/>
				</LabeledField>
			)}

			{selectedCompany && <>
				<LabeledField label={'Theme (Menu Bar)'}>
					<div style={{ display: 'flex' }}>
						<input
							id={'Theme'}
							type="text" className={cls.inputField}
							defaultValue={JSON.stringify(selectedCompany?.company_standards?.themeJ ?? { backgroundColor: 'var(--app-color-gray-dark)', color: 'white' })}
							onChange={e => {
								if (isJson(e.target.value)) {
									setError(false);
									document.getElementById("Theme").style.borderColor = "var(--app-color-gray-lighter)";

								} else {
									setError(true);
									document.getElementById("Theme").style.borderColor = "red";
								}
							}}
							onBlur={e => {
								if (isJson(document.getElementById("Theme")?.value)) {
									setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, themeJ: JSON.parse(e.target.value) } })
								}
							}}
						/>
					</div>
				</LabeledField>

				<LabeledField label={'Theme (Modules Bar)'}>
					<div style={{ display: 'flex' }}>
						<input
							id={'Theme Menu'}
							type="text" className={cls.inputField}
							defaultValue={JSON.stringify(selectedCompany?.company_standards?.themeJM ?? { backgroundColor: '#F6F4EC', color: 'gray' })}
							onChange={e => {
								if (isJson(e.target.value)) {
									setError(false);
									document.getElementById("Theme Menu").style.borderColor = "var(--app-color-gray-lighter)";

								} else {
									setError(true);
									document.getElementById("Theme Menu").style.borderColor = "red";
								}
							}}
							onBlur={e => {
								if (isJson(document.getElementById("Theme Menu")?.value)) {
									setSelectedCompany({ ...selectedCompany, company_standards: { ...selectedCompany?.company_standards, themeJM: JSON.parse(e.target.value) } })
								}
							}}
						/>
					</div>
				</LabeledField>
				{selectedCompany && (
					<LabeledField label={'User Module Link'}>
						<SelectWithSearch
							id={'employee-selection'}
							triggerType={'chevron'}
							itemType={'no-item-icons'}
							className={cls.inputField}
							inputClassName={cls.selectText}
							molclassname={cls.industryMOL}
							moliclassname={cls.industryMOLI}
							inputStyle={{ backgroundColor: 'var(--app-color-gray-lightest)' }}
							onChange={val => {
								selectedCompany.misc_info = { ...selectedCompany?.misc_info, employee: val.value };
							}}
							defaultSelectedItem={allModules.map(mod => ({ label: mod.name, value: mod.id })).find(mod => mod.value === selectedCompany.misc_info?.employee)}
							items={allModules.map(mod => ({ label: mod.name, value: mod.id }))}
						/>
					</LabeledField>
				)}
				{allModules?.find(mod => mod.id === selectedCompany.misc_info?.employee) && <p style={{ fontSize: '14px', marginBottom: '30px' }}>
					{'Note: Make sure that a module with a People field and assigned to option is present to properly link this fucntion.'}
				</p>}
				{selectedCompany && (
					<LabeledField label={'Status locked condition'}>
						<SelectWithSearch
							id={'status-selection'}
							triggerType={'chevron'}
							itemType={'no-item-icons'}
							className={cls.inputField}
							inputClassName={cls.selectText}
							molclassname={cls.industryMOL}
							moliclassname={cls.industryMOLI}
							inputStyle={{ backgroundColor: 'var(--app-color-gray-lightest)' }}
							onChange={val => {
								selectedCompany.misc_info = { ...selectedCompany?.misc_info, lock: val.value };
							}}
							defaultSelectedItem={statusArray.concat(selectedCompany?.misc_info?.status ?? []).find(i => i.value === selectedCompany.misc_info.lock)}
							items={statusArray.concat(selectedCompany?.misc_info?.status ?? [])}
						/>
					</LabeledField>
				)}

				{selectedCompany && (
					<LabeledField label={'Rule Type'}>
						<SelectWithSearch
							id={'position-selection'}
							triggerType={'chevron'}
							itemType={'no-item-icons'}
							className={cls.inputField}
							inputClassName={cls.selectText}
							molclassname={cls.industryMOL}
							moliclassname={cls.industryMOLI}
							inputStyle={{ backgroundColor: 'var(--app-color-gray-lightest)' }}
							onChange={val => {
								setRuleType(val.value);
							}}
							items={rulesTypeArray}
						/>
					</LabeledField>
				)}
				{selectedCompany && ruleType === 'status' && (
					<LabeledField label={''}>
						<SelectWithSearch
							id={'position-selection'}
							triggerType={'chevron'}
							itemType={'no-item-icons'}
							className={cls.inputField}
							inputClassName={cls.selectText}
							molclassname={cls.industryMOL}
							moliclassname={cls.industryMOLI}
							inputStyle={{ backgroundColor: 'var(--app-color-gray-lightest)' }}
							onChange={val => {
								//selectedCompany.coreValues = { ...selectedCompany?.coreValues, singleUser: val.value };
								//selectedCompany.misc_info = { ...selectedCompany?.misc_info, status: val.value };
							}}
							items={selectedCompany?.misc_info?.rules
								?.filter(rul => rul.type === ruleType)
								?.map(rul => {
									return { label: rul.valueCondition, value: rul.valueCondition, rule: rul };
								})}
						/>
					</LabeledField>
				)}
				{selectedCompany && ruleType === 'positions' && (
					<OptionSection >
						<UnfocusableWrapper className={classNames(cls.unfocusableWrapper, cls.peoplePositionSelectContainer)}>

							<LabeledField label={'Field name that will appear in user profile'}>

								<input type="text" className={cls.inputField} style={{ borderRight: selectedCompany?.company_standards?.themeL === 'white' ? '' : `50px solid ${selectedCompany?.company_standards?.themeL ?? '#F6F4EC'}` }}
									defaultValue={selectedCompany?.misc_info?.positionsL ?? 'Position'}
									onChange={e => selectedCompany.misc_info.positionsL = e.target.value}
									onBlur={() => setSelectedCompany(selectedCompany)}
								/>

							</LabeledField>
							<br />
							<MultiselectWithSearchR
								triggerType={'chevron'}
								labelsTag={true}
								tagCloseButtonType={'circleX' /* | "X" */}
								tagType={'shadowed' /* | "step-plated" | "plated" */}
								tagEmplacement={'inlined'}
								items={multiselectItems}
								itemType={'checkboxes'}
								checkboxEmplacement={'left'}
								initialSelectedItems={multiselectItems?.filter(i => selectedCompany?.misc_info?.positions?.indexOf(i.value) > -1)}
								className={cls.uploadSelectComponent}
								inputClassName={cls.uploadSearchInput}
								molclassname={cls.uploadSelectMenuOverlayList}
								moliclassname={cls.uploadSelectMenuOverlayListItem}
								onChange={selection => {
									selectedCompany.misc_info = { ...selectedCompany?.misc_info, positions: selection?.map(i => i?.value) }
								}}
							/>
						</UnfocusableWrapper>
					</OptionSection>

				)}
				{selectedCompany && (
					<LabeledField label={'Templates'}>
						<SelectWithSearch
							id={'position-selection'}
							triggerType={'chevron'}
							itemType={'no-item-icons'}
							className={cls.inputField}
							inputClassName={cls.selectText}
							molclassname={cls.industryMOL}
							moliclassname={cls.industryMOLI}
							inputStyle={{ backgroundColor: 'var(--app-color-gray-lightest)' }}
							onChange={temp => {
								setTemplate(temp.value);
								if (document.getElementById("template value")) {
									document.getElementById("template value").value = JSON.stringify(temp.value);
								}

							}}
							items={selectedCompany?.misc_info?.templatesData
								?.map(rul => {
									return { label: rul.name, value: rul };
								}).concat([{ label: 'New Template', value: { name: 'New', key: {}, config: [], slist: [], tlist: [] } }])}
						/>
					</LabeledField>
				)}
				{template &&
					<LabeledField  >
						<textarea
							id="template value"
							type="text"
							style={{ minHeight: '200px' }}
							className={cls.inputField}
							defaultValue={JSON.stringify(template)}
							onChange={(e) => { }}
							onBlur={() => {
								if (isJson(document.getElementById("template value")?.value)) {
									setTemplate(JSON.parse(document.getElementById("template value")?.value))
									setError(false);
									document.getElementById("template value").style.borderColor = "var(--app-color-gray-lighter)";
								} else {

									if (document.getElementById("template value")?.value.length === 0) {
										document.getElementById("template value").value = JSON.stringify({ name: template?.name, action: 'remove' });
										document.getElementById("template value").style.borderColor = "pink";
										setTemplate({ name: template?.name, action: 'remove' })

									} else {
										setError(true);
										document.getElementById("template value").style.borderColor = "red";
									}

								}
							}}
						/>
					</LabeledField>}
				{selectedCompany && !error && (
					<Button
						loading={loading}
						disabled={template?.name === 'New'}
						style={{ width: '200px' }}
						title={'Update'}
						clicked={() => {
							setLoading(true);
							if (template) {
								if (template?.action === 'remove') {
									selectedCompany.misc_info.templatesData = selectedCompany.misc_info.templatesData?.filter(temp => temp?.name !== template.name);
								} else {
									selectedCompany.misc_info.templatesData = [...selectedCompany.misc_info.templatesData?.filter(temp => temp?.name !== template.name) ?? [], template];
								}
								selectedCompany.misc_info.templates = selectedCompany.misc_info.templatesData?.map(temp => temp?.name);
							}
							updateCompanyDetailsById(selectedCompany)
								.pipe(first())
								.subscribe({
									next: data => {
										if (data.id === companyData?.id) {
											dispatch(setCompanyData(data));
										}
										setTemplate(undefined);
										dispatch(setMessageBar({ show: true, message: `Success, ${data?.display_name} was updated.` })),
											setLoading(false)
									},
									error: () => setLoading(false),
								});
						}}
					/>
				)}
			</>}
		</div>
	);
};
